module.exports = __webpack_public_path__ + "img/info.059d922d.png";